export default "__VITE_ASSET__DCkh7U$o__"